// extracted by mini-css-extract-plugin
export default {"loader":"styles_loader__mh4cl","timer":"styles_timer__w6B1y"};